/** Local-calendar day windows for yesterday snapshot. */

export type DayWindow = {
  start: Date;
  end: Date;
  label: string;
  isoFrom: string;
  isoTo: string;
};

function startOfLocalDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
}

function endOfLocalDay(d: Date): Date {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
}

function isoDate(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

function labelDay(d: Date): string {
  return d.toLocaleDateString(undefined, {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });
}

/** Yesterday (local) and the day before (prior period of equal length). */
export function yesterdayWindows(now = new Date()): { yesterday: DayWindow; prior: DayWindow } {
  const todayStart = startOfLocalDay(now);
  const yStart = new Date(todayStart);
  yStart.setDate(yStart.getDate() - 1);
  const pStart = new Date(todayStart);
  pStart.setDate(pStart.getDate() - 2);

  const yesterday: DayWindow = {
    start: yStart,
    end: endOfLocalDay(yStart),
    label: labelDay(yStart),
    isoFrom: isoDate(yStart),
    isoTo: isoDate(yStart),
  };
  const prior: DayWindow = {
    start: pStart,
    end: endOfLocalDay(pStart),
    label: labelDay(pStart),
    isoFrom: isoDate(pStart),
    isoTo: isoDate(pStart),
  };
  return { yesterday, prior };
}

export function inWindow(iso?: string, win?: DayWindow): boolean {
  if (!iso || !win) return false;
  const t = Date.parse(iso);
  if (!Number.isFinite(t)) return false;
  return t >= win.start.getTime() && t <= win.end.getTime();
}
